module.exports = __webpack_public_path__ + "fonts/icomoon.58ec4116.eot";